"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Transforms a longitude with a z value of a tile coordinate to its corresponding x value of a tile coordinate.
 */

function lng2x(lng, z) {
  return Math.floor((lng + 180) / 360 * Math.pow(2, z));
}

exports.lng2x = lng2x;